"use client";

import { useSyncExternalStore } from "react";

// =============================================================================
// Tiny store telling the page when the intro preloader has finished, so that
// hero animations start once the curtain lifts.
// =============================================================================

let introDone = false;
const listeners = new Set<() => void>();

export function markIntroDone(): void {
  if (introDone) return;
  introDone = true;
  for (const listener of listeners) listener();
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function useIntroDone(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => introDone,
    () => false
  );
}

// =============================================================================
